/**
 * @generated SignedSource<<a287e88acc2e09290da88f06823927e9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type CustomMcpServersSectionQuery$variables = Record<PropertyKey, never>;
export type CustomMcpServersSectionQuery$data = {
  readonly customMcpServers: ReadonlyArray<{
    readonly authType: string;
    readonly createdAt: any;
    readonly description: string | null | undefined;
    readonly discoveredTools: ReadonlyArray<string>;
    readonly id: any;
    readonly isActive: boolean;
    readonly name: string;
    readonly resourceCount: number;
    readonly toolCount: number;
    readonly url: string;
  }>;
};
export type CustomMcpServersSectionQuery = {
  response: CustomMcpServersSectionQuery$data;
  variables: CustomMcpServersSectionQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "GraphQLCustomMcpServer",
    "kind": "LinkedField",
    "name": "customMcpServers",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "description",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "url",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "authType",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isActive",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "discoveredTools",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "toolCount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "resourceCount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "createdAt",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "CustomMcpServersSectionQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "CustomMcpServersSectionQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "90c5d5d2f787d80a0eae285adab30679",
    "id": null,
    "metadata": {},
    "name": "CustomMcpServersSectionQuery",
    "operationKind": "query",
    "text": "query CustomMcpServersSectionQuery {\n  customMcpServers {\n    id\n    name\n    description\n    url\n    authType\n    isActive\n    discoveredTools\n    toolCount\n    resourceCount\n    createdAt\n  }\n}\n"
  }
};
})();

(node as any).hash = "041209c608a100c77972cfecd5f904ef";

export default node;
